<template>
  <div class="main">
    <report-top
      ><template slot="search">
        <ly-search v-model="searchItem.keyword" @search="search"></ly-search>
      </template>
    </report-top>
    <div id="formTable">
      <div class="formTableItem">
        <p class="label">单位筛选</p>
        <selectAlotGroup
          placement="left"
          @groupIdList="
            searchItem.groupIdList = $event;
            getList();
          "
        ></selectAlotGroup>
      </div>
      <div id="ddas">
        <Button @click="exportAll" icon="md-download">导出</Button>
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <Modal
      v-model="openForm"
      :title="isAdd ? '新增物联网卡' : '编辑物联网卡：' + item.simNo"
      footer-hide
      width="700"
      height="400"
      @on-cancel="cliclCancelBtn"
    >
      <Form ref="item" :model="item" :rules="ruleValidate" :label-width="80">
        <Row :gutter="16"
          ><Col span="12">
            <FormItem label="开卡人" prop="openerName">
              <Input v-model="item.openerName" placeholder="请输入"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="厂商" prop="firmName">
              <Input v-model="item.firmName" placeholder="请输入"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="运营商" prop="isp">
              <Select v-model="item.isp">
                <Option
                  v-for="(x, index) in $t('isp')"
                  :value="index"
                  :key="index"
                  >{{ x }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="套餐" prop="meal">
              <Input v-model="item.meal" placeholder="请输入"></Input>
            </FormItem> </Col
          ><Col span="12">
            <FormItem label="采购时间" prop="purchaseTime1">
              <DatePicker
                type="date"
                placeholder="请选择"
                v-model="item.purchaseTime1"
              ></DatePicker>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="备注" prop="remark">
              <Input
                v-model="item.remark"
                type="textarea"
                placeholder="请输入"
              ></Input>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex" justify="end">
          <Col span="24">
            <div class="btn-wrap">
              <Button @click="resetForm">重置表单</Button>
              <Button type="primary" @click="addUpdate('item')"
                >提交表单</Button
              >
            </div>
          </Col>
        </Row>
      </Form>
    </Modal>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      openForm: false,
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "sim卡号",
          key: "simNo",
        },
        {
          title: "所属单位",
          key: "groupName",
        },
        {
          title: "开卡人",
          key: "openerName",
        },
        {
          title: "套餐",
          key: "meal",
        },
        {
          title: "采购时间",
          key: "purchaseTime2",
        },
        {
          title: "到期时间",
          key: "expiredTime2",
        },
        {
          title: "厂商",
          key: "firmName",
        },
        {
          title: "使用状态",
          key: "useState",
          render: (h, data) => {
            return h("div", this.$t("useState." + data.row.useState));
          },
        },
        {
          title: "运营商",
          key: "useState",
          render: (h, data) => {
            return h("div", this.$t("isp." + data.row.isp));
          },
        },
        {
          title: "备注信息",
          key: "remark",
        },
        {
          title: "创建者账号",
          key: "createAccount",
        },
        {
          title: "创建时间",
          key: "createTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
        },
        {
          title: "操作",
          slot: "action",
          width: 130,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        groupId: 0,
        groupName: "",
        simNo: "",
      },
      ruleValidate: {
        simNo: { required: true, message: "必填" },
        groupName: { required: true, message: "必填" },
      },
      searchItem: {
        groupIdList: [],
        keyword: "",
        pageSize: 50,
        pageNumber: 1,
      },
      total: 0,
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.dm + "/iotCard/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].isp = String(data[i].isp);
          data[i].expiredTime1 = this.utils.sjcTo(data[i].expiredTime);
          data[i].expiredTime2 = this.utils.time(data[i].expiredTime, "yymmdd");
          data[i].purchaseTime1 = this.utils.sjcTo(data[i].purchaseTime);
          data[i].purchaseTime2 = this.utils.time(
            data[i].purchaseTime,
            "yymmdd"
          );
        }
        this.tableData = data;
        console.log(data);
      });
    },
    exportAll() {
      var params = [
        {
          name: "keyword",
          value: this.searchItem.keyword,
        },
        {
          name: "groupIdList",
          value: this.searchItem.groupIdList,
        },
      ];
      this.utils.exportData(axios.dm + "/iotCard/export", params);
    },
    addUpdate(name) {
      console.log(this.item);
      this.$refs[name].validate((valid) => {
        this.item.expiredTime = this.utils.toSjc(this.item.expiredTime1);
        this.item.purchaseTime = this.utils.toSjc(this.item.purchaseTime1);
        if (valid) {
          if (this.isAdd) {
            axios({
              method: "post",
              url: axios.dm + "/iotCard/add",
              data: this.item,
            }).then((res) => {
              if (res) {
                this.openForm = false;
                this.getList();
              }
            });
          } else {
            axios({
              method: "post",
              url: axios.dm + "/iotCard/update",
              data: this.item,
            }).then((res) => {
              console.log(res);
              if (res) {
                this.openForm = false;
                this.getList();
              }
            });
          }
        }
      });
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          axios({
            method: "post",
            url: axios.dm + "/iotCard/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.openForm = true;
      this.isAdd = false;
      this.item = row;
    },
    openAdd() {
      this.openForm = true;
      this.isAdd = true;
    },
    resetForm() {
      this.$refs["item"].resetFields();
    },
    cliclCancelBtn() {
      this.openForm = false;
      var arr = this.tableData;
      this.tableData = [];
      setTimeout(() => {
        this.tableData = arr;
      }, 200);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/information/iotCard.vue